<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="12"
  viewBox="0 0 16 12"
  fill="none"
  aria-hidden="true"
>
  <g clip-path="url(#clip_store_sy_flag)">
    <path d="M0 0H16V4H0V0Z" fill="#007A3D" />
    <path d="M0 4H16V8H0V4Z" fill="#FFFFFF" />
    <path d="M0 8H16V12H0V8Z" fill="#000000" />
    <path
      d="M4.2 6.05L4.55 7.05L3.75 6.45H4.65L3.85 7.05L4.2 6.05Z"
      fill="#CE1126"
    />
    <path
      d="M8 6.05L8.35 7.05L7.55 6.45H8.45L7.65 7.05L8 6.05Z"
      fill="#CE1126"
    />
    <path
      d="M11.8 6.05L12.15 7.05L11.35 6.45H12.25L11.45 7.05L11.8 6.05Z"
      fill="#CE1126"
    />
  </g>
  <defs>
    <clipPath id="clip_store_sy_flag">
      <rect width="16" height="12" fill="white" />
    </clipPath>
  </defs>
</svg>